// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./DayTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Day-module__Day__Sdhd1 {
    position: relative;
    display: flex;
    flex-basis: var(--ds-10x);
    flex-direction: column;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    min-width: var(--ds-10x);
    height: var(--ds-10x);
    padding: var(--ds-1x);
    /* stylelint-disable-next-line property-disallowed-list -- DS component */
    font-weight: var(--ds-font-weight-medium);
    /* stylelint-disable-next-line property-disallowed-list -- DS component */
    font-size: var(--ds-text-small);
    background-color: var(--ds-day-bg-color);
    border-radius: var(--ds-border-radius-sm);
    cursor: pointer;

    &:hover {
        background-color: var(--ds-day-hover-bg-color);
    }

    &:focus-visible {
        outline: var(--ds-05x) solid var(--ds-day-focus-outline-color);
    }
}

.Day-module__DaySelected__vwNy2 {
    background-color: var(--ds-day-selected-bg-color);

    &:hover {
        background-color: var(--ds-day-selected-hover-bg-color);
    }
}
/* Text Colors */
.Day-module__DayInMonthColor__sLAWw {
    color: var(--ds-day-text-color);
}

.Day-module__DayOtherMonthColor__k9buR {
    color: var(--ds-day-other-month-text-color);
}

.Day-module__SelectedDayColor__VBrmM {
    color: var(--ds-day-selected-text-color);
}

.Day-module__DayDisabled__p3QIC {
    color: var(--ds-day-disabled-text-color);
    background-color: var(--ds-day-disabled-bg-color);
}
/* Text Colors */
/* Dot */
.Day-module__Dot__E4grF::after {
    position: absolute;
    bottom: var(--ds-2x);
    width: var(--ds-1x);
    height: var(--ds-1x);
    border-radius: var(--ds-border-radius-circle);
    content: '';
}

.Day-module__CurrentDayDot___87Ik::after {
    background-color: var(--ds-color-neon-0);
}

.Day-module__CurrentDayDotSelected__L5I1O::after {
    background-color: var(--ds-color-grey-indigo-50);
}

.Day-module__CurrentDayDotDisabled__bptNg::after {
    background-color: var(--ds-color-neon-0);
}
/* Dot */
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Day": `Day-module__Day__Sdhd1`,
	"DaySelected": `Day-module__DaySelected__vwNy2`,
	"DayInMonthColor": `Day-module__DayInMonthColor__sLAWw`,
	"DayOtherMonthColor": `Day-module__DayOtherMonthColor__k9buR`,
	"SelectedDayColor": `Day-module__SelectedDayColor__VBrmM`,
	"DayDisabled": `Day-module__DayDisabled__p3QIC`,
	"Dot": `Day-module__Dot__E4grF`,
	"CurrentDayDot": `Day-module__CurrentDayDot___87Ik`,
	"CurrentDayDotSelected": `Day-module__CurrentDayDotSelected__L5I1O`,
	"CurrentDayDotDisabled": `Day-module__CurrentDayDotDisabled__bptNg`
};
export default ___CSS_LOADER_EXPORT___;
